import React, {useState, useEffect} from 'react';
import Navbar from "../components/Navbar";
import {Outlet, useLocation} from "react-router-dom";
import Footer from "../components/Footer";
import { useModal } from "../components/Modal";

const SharedLayout = () => {
    const { pathname } = useLocation();

    const {
        showModal,
        handleHideModal,
        showModalInfo,
        handleHideModalInfo,
        showModalInfoTransport,
        handleHideModalInfoTransport
    } = useModal();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        const wrapper = document.querySelector("body");
        if (showModal) {
            wrapper.classList.add("freeze");
        } else {
            wrapper.classList.remove("freeze");
        }
    }, [showModal]);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        spamcontrol: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false); // Stav pro deaktivaci tlačítka

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Kontrola spamu - musí být číslo 5
        if (formData.spamcontrol !== "5") {
            alert("Kontrola spamu má špatnou hodnotu. Zkuste to znovu.");
            return;
        }

        setIsSubmitting(true); // Deaktivace tlačítka během odesílání

        try {
            const response = await fetch("https://rychlydum.cz/phpmailer/form-handler.php", {
                method: "POST",
                body: JSON.stringify(formData),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const result = await response.json();

            if (result.status === "success") {
                alert("Formulář byl úspěšně odeslán.");
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    spamcontrol: "",
                    message: "",
                }); // Vyčištění formuláře

            } else {
                alert("Chyba při odesílání formuláře. Zkuste to znovu.");
            }
        } catch (error) {
            alert("Chyba při spojení se serverem.");
        }

        setIsSubmitting(false); // Opětovné povolení tlačítka
    };

    return (
        <>
            <div className="wrapper">
                <Navbar />
                <Outlet />
                <Footer />
            </div>
            {showModal && (
                <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block" }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>Kontaktní formulář</h2>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleHideModal}>
                                    zavřít
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label>Jméno<span className="required">*</span></label>
                                        <input type="text" name="name" value={formData.name} onChange={handleChange} required className="form-control" />
                                    </div>
                                    <div className="form-group">
                                        <label>E-mail<span className="required">*</span></label>
                                        <input type="email" name="email" value={formData.email} onChange={handleChange} required className="form-control" />
                                    </div>
                                    <div className="form-group">
                                        <label>Telefon<span className="required">*</span></label>
                                        <input type="number" name="phone" value={formData.phone} onChange={handleChange} required className="form-control" />
                                    </div>
                                    <div className="form-group spam">
                                        <label>Kontrola spamu<span className="required">*</span> 3+2=</label>
                                        <input type="text" name="spamcontrol" value={formData.spamcontrol} onChange={handleChange} required className="form-control" />
                                    </div>
                                    <div className="form-group w-100">
                                        <textarea name="message" placeholder="Zde napište svoji zprávu..." value={formData.message} onChange={handleChange} required className="form-control" />
                                    </div>
                                    <p>
                                        Odesláním formuláře souhlasíte se zpracováním zadaných údajů pro případné kontaktování naším pracovníkem.<br />
                                        Zadané údaje budou uchovány správcem pouze po nezbytně nutnou dobu a nebudou bez souhlasu dále předávány.
                                    </p>
                                    <button type="submit" className="bttn" disabled={isSubmitting}>
                                        {isSubmitting ? "Odesílání" : "Odeslat"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModalInfo && (
                <div className="modal" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>Možnost úpravy dispozice dle požadavků</h2>
                                <button className="close" data-dismiss="modal" aria-label="Close" onClick={handleHideModalInfo}>zavřít</button>
                            </div>
                            <div className="modal-body text-aling-center">
                                <p><strong>Vnitřní uspořádání příček, dispozic, sklonu střechy nebo velikosti domu lze přizpůsobit vašemu požadavku.</strong></p>
                                <p>Tyto požadavky mohou mít vliv na prezentovanou cenu.</p>
                                <p>Pokud máte zájem o vlastní řešení, kontaktujte nás prosím pro vytvoření cenové kalkulace.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showModalInfoTransport && (
                <div className="modal" style={{ display: "block" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>Doprava do 100 km od výrobní haly zdarma</h2>
                                <button className="close" data-dismiss="modal" aria-label="Close" onClick={handleHideModalInfoTransport}>zavřít</button>
                            </div>
                            <div className="modal-body text-aling-center">
                                <p>
                                    <strong>Dopravu domu na váš pozemek v okruhu do 100 km od výrobní haly od nás získáte zdarma.</strong><br />
                                    <strong>Naše výrobní hala se nachází v obci Lužec nad Vltavou v okrese Mělník.</strong>
                                </p>
                                <p>V případě, že se váš pozemek nachází ve větší vzdálenosti, zpracujeme vám individuální kalkulaci na zbývající km.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default SharedLayout;
